import React, { useEffect, useRef } from "react";

import { useHistory } from "react-router-dom";

import Icon from "../icon";
import Icons from "../icons-helper";

import { svgs } from "../../assets";

import { DropDown, DropDownOption } from "./styled";

import * as S from "./styled";

import { theme } from "../../styles/theme";

import { useAuthGlobal } from "../../../contexts/auth-context/auth-context";
import { useMenu, Actions } from "../../../contexts/menu";

const Navbar: React.FC = () => {
  const [dropDown, setDropDown] = React.useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const { dispatch } = useMenu();

  const { user } = useAuthGlobal();

  const history = useHistory();

  const isSuperAdmin = !!user?.roles?.find(
    (it: any) => it?.authority === "SUPERADMIN",
  );

  const options = [
    {
      name: "Meu Perfil",
      icon: "people",
      push: "/profile",
      show: !window.location.pathname.includes("/admin"),
    },
    {
      name: "Empresas",
      icon: "people",
      push: "/companies",
      show: !window.location.pathname.includes("/admin") && isSuperAdmin,
    },
    {
      name: "Sair",
      icon: "exit",
      push: "/exit",
      show: true,
    },
  ];

  const toggleDropDown = (): void => {
    setDropDown(!dropDown);
  };

  const toggleMenu = (): void => {
    dispatch({ type: Actions.TOGGLE_MENU_DEVELOPER });
  };

  const handleOptionClick = (push: string): void => {
    history.push(push);
    setDropDown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropDown(false);
      }
    };

    if (dropDown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropDown]);

  return (
    <S.Container>
      <S.Logo src={svgs.Logo} alt="logo" />

      <S.Items>
        <S.IconContainer>
          <Icon name="profile-picture" width={13} height={17.5} />
        </S.IconContainer>

        <button onClick={toggleDropDown} type="button">
          {user?.name || ""}
          <br />
          {user?.developerResponseDTO ? "Cliente" : "Admin"}
          <Icon name="arrow-down" aria-label="arrow-down" />
        </button>

        <Icon
          name="menu"
          width={15}
          height={15}
          aria-label="menu-icon"
          onClick={toggleMenu}
        />
      </S.Items>
      {dropDown && (
        <DropDown id="dropdown-menu" ref={dropdownRef}>
          <>
            {options.map((option, index) => (
              <DropDownOption
                key={index}
                onClick={() => {
                  toggleDropDown();
                  handleOptionClick(option.push);
                }}
                show={option.show}
              >
                <Icons
                  name={option.icon}
                  width={15}
                  height={15}
                  color={theme.colors.white}
                />
                {option.name}
              </DropDownOption>
            ))}
          </>
        </DropDown>
      )}
    </S.Container>
  );
};

export default Navbar;
